import { z } from "zod";

export const customerStatusSchema = z.enum(["ACTIVE", "ARCHIVED"]);

export const customerViewSchema = z.object({
  id: z.string(),
  name: z.string(),
  aliases: z.array(z.string()),
  note: z.string(),
  status: customerStatusSchema,
  createdAt: z.string(),
  updatedAt: z.string(),
  revision: z.number(),
});
export type CustomerView = z.infer<typeof customerViewSchema>;

export const customerListResponseSchema = z.object({ customers: z.array(customerViewSchema) });
export type CustomerListResponse = z.infer<typeof customerListResponseSchema>;
export const customerResponseSchema = z.object({ customer: customerViewSchema });
export type CustomerResponse = z.infer<typeof customerResponseSchema>;

export const customerListQuerySchema = z.object({ status: customerStatusSchema.optional() });

export const createCustomerRequestSchema = z.object({
  name: z.string().trim().min(1, "顧客名は必須です").max(200),
  aliases: z.array(z.string().trim().max(200)).max(50).optional(),
  note: z.string().max(5000).optional(),
});
export type CreateCustomerRequest = z.infer<typeof createCustomerRequestSchema>;

export const updateCustomerRequestSchema = z.object({
  revision: z.number().int().positive(),
  name: z.string().trim().min(1).max(200).optional(),
  aliases: z.array(z.string().trim().max(200)).max(50).optional(),
  note: z.string().max(5000).optional(),
});
export type UpdateCustomerRequest = z.infer<typeof updateCustomerRequestSchema>;

export const changeCustomerStatusRequestSchema = z.object({
  revision: z.number().int().positive(),
  status: customerStatusSchema,
});
export type ChangeCustomerStatusRequest = z.infer<typeof changeCustomerStatusRequestSchema>;
